// * Components
import Hero from "./components/Hero";
import Reviews from "./components/Reviews";
import Guide from './components/Guide'
import Properties from "./components/Properties";
import MoreDetail from "./components/MoreDetail";
import Featured from "./components/Featured";
import Waitlist from "./components/Waitlist";
import Footer from "./components/Footer";
import ScrollSection from "./components/ScrollSection";


function App() {

  return (
    <div className="App" style={{ position: "relative" }}>
      {/* Fixed Animated Background */}
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        background: 'linear-gradient(45deg, #8dd9ed, #6b95ff, #8dd9ed, #6b95ff)',
        backgroundSize: '400% 400%',
        animation: 'gradientShift 15s ease infinite',
      }}>
      </div>

      {/* Content that scrolls over the background */}
      <div style={{ position: "relative", zIndex: 1 }}>
        <div id="home">
          <ScrollSection direction="fade">
            <Hero />
          </ScrollSection>
        </div>

        <div id="how-it-works">
          <ScrollSection direction="up" delay={0.2}>
            <Guide />
          </ScrollSection>
        </div>

        <div id="features">
          <ScrollSection direction="fade" delay={0.1}>
            <MoreDetail />
          </ScrollSection>
          <ScrollSection direction="up" delay={0.2}>
            <Properties />
          </ScrollSection>
        </div>

        <div id="security">
          <ScrollSection direction="fade">
            <Featured />
          </ScrollSection>
        </div>

        <div id="about">
          <ScrollSection direction="up" delay={0.1}>
            <Reviews />
          </ScrollSection>
        </div>

        <div id="waitlist">
          <ScrollSection direction="fade" delay={0.2}>
            <Waitlist />
          </ScrollSection>
        </div>

        <ScrollSection direction="up">
          <Footer />
        </ScrollSection>
      </div>
    </div>
  );
}

export default App;
